import React from 'react'
import {
  Map,
  fromJS,
  List,
} from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import {
  EPISODE_TAB_VALUE,
  DETAIL_PAGE_STATIC_KEY,
} from '../../../services/detail/index'
import {
  isSeries,
  getLocationType,
  getFeaturedContent,
  isSubtypeYogaFitnessMeditation,
  getAudioLanguages,
  getSubtitleCaptionLanguages,
} from '../../../services/content/index'
import {
  TYPE_CONTENT_VIDEO,
} from '../../../services/content-type/index'
import { hasLiveAccessEntitlement } from '../../../services/subscription/index'
import ReadMoreLess from '../../ReadMoreLess/index'
import LabeledField from '../../LabeledField/index'
import Vote, { SIZE_MEDIUM } from '../../Vote/index'
import FileAttachmentsGraphQL from '../../FileAttachmentsGraphQL/index'
import DetailActionButtons from '../DetailActionButtons'
import DetailContentLayoutTemplate from '../DetailContentLayoutTemplate'
import { getDetailPageUiLocationGQL } from '../utils'

function DetailVideoEpisode (props) {
  const {
    auth,
    tabData = Map(),
    staticText,
    isSeriesDetailPage,
  } = props
  const featuredContent = getFeaturedContent({ data: tabData })
  const contentType = tabData.get('contentType')
  const audioLanguages = getAudioLanguages({ data: tabData, contentType })
  const subtitleCaptionLanguages = getSubtitleCaptionLanguages({ data: tabData, contentType })
  const detailLocationType = getLocationType({ data: tabData })
  let description = tabData.get('description')
  let host = tabData.get('instructor')
  let guest = tabData.get('cast')
  let isYogaFitnessMeditation = isSubtypeYogaFitnessMeditation({
    contentSubtype: tabData.get('contentSubtype'),
  })
  let vote = tabData.get('vote') || Map()
  let id = tabData.get('contentId')
  let title = tabData.get('title')
  let seriesId = tabData.get('seriesId')
  let seriesTitle = tabData.get('seriesTitle')
  let fileAttachmentData = tabData.get('assets') || List()

  if (isSeriesDetailPage) {
    description = featuredContent.get('description')
    host = featuredContent.get('instructor')
    guest = featuredContent.get('cast')
    vote = featuredContent.get('vote') || Map()
    id = featuredContent.get('contentId')
    title = featuredContent.get('title')
    seriesId = tabData.get('contentId')
    seriesTitle = tabData.get('title')
    isYogaFitnessMeditation = isSubtypeYogaFitnessMeditation({
      contentSubtype: featuredContent.get('contentSubtype'),
    })
    fileAttachmentData = featuredContent.get('assets') || List()
  }

  const ga4EventData = fromJS({
    content_id: id,
    content_type: TYPE_CONTENT_VIDEO,
    content_name: title,
    parent_series_id: seriesId,
    parent_series_name: seriesTitle,
    ui_location: getDetailPageUiLocationGQL(detailLocationType),
  })

  return (
    <DetailContentLayoutTemplate
      rowOne={
        <DetailActionButtons
          activeTabValue={EPISODE_TAB_VALUE}
          tabData={tabData}
          isInlinePlaybackActive={props.isInlinePlaybackActive}
        />
      }
      rowTwo={
        <>
          <ReadMoreLess text={description} maxLength={700} />
        </>
      }
      rowThree={
        <div className="detail-page__content-meta-info">
          <LabeledField
            value={host}
            label={isYogaFitnessMeditation ? staticText.get('teacher') : staticText.get('host')}
          />
          <LabeledField
            value={guest}
            label={staticText.get('featuring')}
          />
          {
            audioLanguages
              ? <LabeledField
                  value={audioLanguages}
                  label={staticText.get('audio')}
                />
              : null
          }
          {
            subtitleCaptionLanguages
              ? <LabeledField
                  value={subtitleCaptionLanguages}
                  label={staticText.get('subtitles')}
                />
              : null
          }
        </div>
      }
      rowFour={
        <Vote
          className="detail-page__content-meta-vote"
          size={SIZE_MEDIUM}
          vote={vote.get('upVote')}
          voteDown={vote.get('downVote')}
          voteId={id}
          auth={auth}
          ga4EventData={ga4EventData}
          userVote={tabData.get('userVote')}
        />
      }
      rowFive={
        <FileAttachmentsGraphQL
          data={fileAttachmentData}
          sectionTitle={staticText.get('bonusMaterials')}
        />
      }
    />
  )
}

export default compose(
  connectRedux(
    (state, props) => {
      const {
        auth,
      } = state
      const { tabData = Map() } = props
      const contentType = tabData.get('contentType')
      const subscriptions = auth.get('subscriptions')
      const hasLiveAccess = hasLiveAccessEntitlement(subscriptions)

      return {
        auth,
        staticText: state.staticText.getIn(['data', DETAIL_PAGE_STATIC_KEY, 'data']),
        isSeriesDetailPage: isSeries({ contentType }),
        hasLiveAccess,
      }
    },
  ),
)(DetailVideoEpisode)
